export const OptionalField = [
  {
    name: 'SGST',
    field: 'sgst',
    selected: true,
  },
  {
    name: 'CGST',
    field: 'cgst',
    selected: true,
  },
  {
    name: 'Discount',
    field: 'discount',
    selected: true,
  },
  {
    name: 'Discount (%)',
    field: 'discountInPercentage',
    selected: true,
  },
  {
    name: 'HSN Number',
    field: 'hsnNumber',
    selected: true,
  },
  {
    name: 'Free Qty',
    field: 'free',
    selected: true,
  },
  {
    name: 'Generic',
    field: 'generic',
    selected: true,
  },
]

export const OptionalColumnField = [
  {
    name: 'SGST',
    id:'SGST',
    selected: true,
    
  },  
  {
    name: 'CGST',
    id:'CGST',
    selected: true,
  },
  {
    name: 'Discount',
    id:'DISCOUNT',
    selected: true,
  },
  {
    name: 'Discount (%)',
    id:'DISCOUNT_IN_PERCENTAGE',
    selected: true,
  },
  {
    name: 'HSN Number',
    id:'HSNCODE',
    selected: true,

  },
  {
    name: 'Free Qty',
    id:'FREE',
    selected: true,

  },
  {
    name: 'Generic',
    id:'GENERIC',
    selected: true,
  },
]

export type ColumnVisibility = {
  PRODUCT_ID: boolean;
  SGST: boolean;
  CGST: boolean;
  DISCOUNT: boolean;
  DISCOUNT_IN_PERCENTAGE: boolean;
  HSNCODE: boolean;
  FREE: boolean;
  [key: string]: boolean; // Index signature
};


